;(function () {

"use strict";

var SliderView = require('../views/slider');

var ProductFormView = require('../views/product-form');

var GalleryView = require('../views/gallery');

var SocialMediaView = require('../views/social-media');

var VerticalTabsView = require('../views/vertical-tabs');

var RecentlyViewedProductsTemplate = require('../views/templates/recently-viewed-products.html');
var RecentlyViewedProductTemplate = require('../views/templates/recently-viewed-product.html');

var ProductVerticalTabsView = VerticalTabsView.extend({
  initialize: function (opts) {
    opts = opts || {};

    VerticalTabsView.prototype.initialize.call(this);

    this.guid = window.App.guid();

    $(window).on('resize.'+this.guid, _.bind(this.resize, this));
    this.resize();
  },
  resize: function () {
    // this.$el.offset();

    var h = $('.product-single > .left').height();
    var pt = this.$el.position().top;
    var th = ((Math.ceil(this.$tabs.children('h6').first().outerHeight()) + 1) * this.$tabs.children('h6').length) + 20 + (2 * this.$tabs.children('h6').length);
    var mh = h - pt - th;

    if (mh < 120) {
      mh = 120;
    }

    this.$el.find('.content').css('max-height', mh);
  }
});

function saveToRecentlyViewed() {
  var recentlyViewed = { products: [] };

  if (window.localStorage.getItem('recently_viewed')) {
    recentlyViewed = JSON.parse(window.localStorage.getItem('recently_viewed'));
  }

  if (window.CurrentlyViewedProduct) {
    recentlyViewed.products.unshift(window.CurrentlyViewedProduct);
    recentlyViewed.products = _.uniq(recentlyViewed.products, function (p) {
      return p.handle;
    });

    recentlyViewed.products = recentlyViewed.products.slice(0, 100);
    window.localStorage.setItem('recently_viewed', JSON.stringify(recentlyViewed));
  }
}

function renderRecentlyViewed() {
  var recentlyViewed = { products: [] };

  if (window.localStorage.getItem('recently_viewed')) {
    recentlyViewed = JSON.parse(window.localStorage.getItem('recently_viewed'));
  }
  
  var products = [];
  recentlyViewed.products.forEach(function (product) {
    if (window.CurrentlyViewedProduct && product.handle === window.CurrentlyViewedProduct.handle) {
      // console.log('SKIPPING');
      // console.log(product.handle);
      // console.log(CurrentlyViewedProduct.handle);
    } else {
      var now = new Date().valueOf();
      var diffDays = (now - product.published_date) / 1000 / 3600 / 24;

      if (diffDays < 10) {
        product.badge = 'new';
      }

      if (product.on_sale) {
        product.badge = 'sale';
      }

      product.tags = product.tags || '';
      var tags = product.tags.split(',');

      if (tags.indexOf('exclusive') !== -1) {
        product.badge = 'exclusive';
      }

      if (tags.indexOf('best-seller') !== -1) {
        product.badge = 'best-seller';
      }

      // console.log(product);

      products.push(_.template(RecentlyViewedProductTemplate)({ product: product }));
    }
  });

  if (products.length >= 1) {

    var $recentlyViewed = $(_.template(RecentlyViewedProductsTemplate)({ products: products }));

    $recentlyViewed.find('.slider.desktop .slide').each(function (idx) {
      if (idx < 3) {
        $(this).addClass('active');
      }
    });

    $recentlyViewed.find('.slider.mobile .slide').first().addClass('active');
    $recentlyViewed.insertAfter($('.section.related-products'));

    // console.log(products);

    var self = this;
    setTimeout(function () {
      new SliderView({ el: $recentlyViewed.find('.slider.desktop'), group: 3 });
      new SliderView({ el: $recentlyViewed.find('.slider.mobile') });
    }, 0);

  }
}

var validateEmail = function (email) {
  if (!email) { return false; }

  var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(email);
}

var ConsultationFormView = Backbone.View.extend({
  initialize: function () {
    var self = this;
    var $form = this.$el;
    this.$form = $form;

    $form.on('submit', function (e) {
      e.preventDefault();
      e.stopPropagation();

      var invalid = false;

      $form.find('input, textarea, select').each(function (el) {

        if ($(this).attr('type') === 'email') {

          if (!validateEmail($(this).val())) {
            $(this).addClass('error');
            invalid = true;
          } else {
            $(this).removeClass('error');
          }

        } else if (!$(this).val() && !$(this).hasClass('optional')) {
          $(this).addClass('error');
          invalid = true;
        } else {
          $(this).removeClass('error');
        }
      });

      if (!invalid) {
        self.submitForm();
      }

      return false;
    });
  },

  submitForm: function () {
    this.$form.find('button[type="submit"]').addClass('success');

    var self = this;
    var url = "//dev.roseandrex.com/positive-language-consult";

    $.post(url, self.$form.serialize(), function (d) {
      if (d && d.status === 'success') {
        self.$form.find('.group').toggleClass('hidden');
        self.$form.find('h3 > span').css({opacity: 0});
        var pt = $('.consultation-form').position().top - 100;
        $('html, body').animate({scrollTop: pt}, '1000');
      } else {
        alert('Something went wrong, please try again');
        self.$form.find('button[type="submit"]').removeClass('success');
      }
    }, "json");
  }
})

var PageView = Backbone.View.extend({
  initialize: function () {
    new SliderView({ el: this.$el.find('.products-slider .slider.desktop'), group: 3 });

    new SliderView({ el: this.$el.find('.products-slider .slider.mobile') });

    new GalleryView({ el: this.$el.find('.gallery') });

    new ProductFormView({ el: this.$el.find('#AddToCartForm') });

    new SocialMediaView({ el: this.$el.find('ul.share') });
    new SocialMediaView({ el: this.$el.find('ul.share-alt') });

    new ProductVerticalTabsView({ el: this.$el.find('.vertical-tabs').first() });

    renderRecentlyViewed();

    setTimeout(function () {
      saveToRecentlyViewed();
    }, 0);

    $('button.add-to-cart').on('click', function () {
      $('#AddToCart').trigger('click');
    });

    if (this.$el.find('.past-partners .slider.mobile')[0]) {
      new SliderView({ el: this.$el.find('.past-partners .slider.mobile') });
    }

    if ($('#positive-language-consultation-form')[0]) {
      new ConsultationFormView({ el: $('#positive-language-consultation-form') })
    }
  }
});

module.exports = PageView;

}());